<template>
  <div
    class="column-wrap"
    :class="{active: active}"
    :style="{backgroundImage: `url(${bgImg})`,backgroundColor: bgCol}"
  >
    <div class="column-inner">
      <div class="column-title" v-if="titleV" :style="{color: titCol}" v-html="title"></div>
      <div class="sub-title" v-if="subTitleV" :style="{color: subCol}" v-html="subTitle"></div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'moduleWrap',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    bgImg: {
      type: String,
      default: '',
    },
    titCol: {
      type: String,
      default: '#333333',
    },
    subCol: {
      type: String,
      default: '#929caa',
    },
    bgCol: {
      type: String,
      default: '',
    },
    title: {
      type: String,
    },
    subTitleV: {
      type: Boolean,
      default: true,
    },
    titleV: {
      type: Boolean,
      default: true,
    },
    subTitle: {
      type: String,
    },
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util.scss';
.column-wrap {
  width: 100%;
  padding: 80px 0;
  @include bgConfig;
  background-color: #fff;
  &.active{
    .column-title,.sub-title{
      opacity: 1 !important;
      transform: translate(0,0) !important;
    }

  }
  .column-inner {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .column-title {
    font-size: 32px;
    font-weight: bold;
    letter-spacing: 1px;
    opacity: 0;
    transition: all .3s linear;
    transform: translate(0, 200px);
  }
  .sub-title {
    font-size: 16px;
    letter-spacing: 0.5px;
    margin-top: 8px;
    margin-bottom: 40px;
    opacity: 0;
    transition: all .4s linear;
    transition-delay: 0.1s;
    transform: translate(0, 200px);
  }
}
</style>